import NetIncomeChart from './NetIncomeChart'

const NetIncome = ({ data }) => {
    return data && data.length ? (
        <>
            <h3 className="text-center" style={{marginTop: 0}}>Net Income</h3>
            <div className="spc-p-b-2">
                <NetIncomeChart data={data} />
            </div>
        </>
    ) : null
}

export default NetIncome
